
import { INACTIVE_TAG_BG, DROPDOWN_TAG_ICON, ICON_ADIL, GAME_TOKEN_MERAH } from 'assets/images'
import { useRef, useState } from 'react'
import SelectBoxStyled from './styled'
import { useOnClickOutside } from 'hooks'

interface PropsSelectBox {
  nameSelect?: string
  dataSelect: { name: string, isActive?: boolean, image?: string }[]
  onSelected: (item: string) => void
  customClass?: string
  clipPath?: number
}
function SelectRanking({ nameSelect, dataSelect, onSelected, customClass = '', clipPath = 92.7 }: PropsSelectBox) {
  const selectRef = useRef(null)
  const IMG_SELECTED = nameSelect == 'MERAH' ? GAME_TOKEN_MERAH : nameSelect == 'ADIL' ? ICON_ADIL : ''
  const [show, setShow] = useState(false)

  useOnClickOutside(selectRef, e => {
    if (e.target == selectRef.current) {
      return
    }
    setShow(false)
  })
  return (
    <SelectBoxStyled clipPath={clipPath}>
      <div className={`select-box-customs ${customClass}`} onClick={() => setShow(!show)} ref={selectRef}>
        <img src={INACTIVE_TAG_BG} alt='' />
        <span className='select-name'>
          {nameSelect}
          {IMG_SELECTED ? (
            <img src={IMG_SELECTED} alt="" className='image-coin'/>
          ) : ''}
        </span>
        <img
          className={!show ? 'select-drop-icon ' : 'select-drop-icon up-down-icon '}
          src={DROPDOWN_TAG_ICON}
          alt=''
        />
        {show && (
          <ul className='select-content-dropdown'>
            <div className='space_content'></div>
            {dataSelect.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  onSelected(item.name)
                  setShow(false)
                }}
                className={nameSelect == item.name ? 'active' : ''}
              >
                {item.name}
                {item?.image ? (
                  <img src={item?.image} alt="" />
                ) : ''}
              </li>
            ))}
            <div className='space_content_last'></div>
          </ul>
        )}
      </div>
    </SelectBoxStyled>
  )
}
export default SelectRanking
